import { colors } from '../sharedStyles';

export default function Expertise() {
    return (
        <section id="expertise" style={{ paddingTop: '6rem', paddingBottom: '6rem', backgroundColor: colors.white }}>
            <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '0 1.5rem' }}>
                <div style={{ textAlign: 'center', marginBottom: '5rem' }}>
                    <h2 className="fade-in-up" style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', fontWeight: 800, color: colors.primary, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '2px' }}>
                        Expertise et bénéfices
                    </h2>
                    <div style={{ width: '4rem', height: '4px', backgroundColor: colors.secondary, margin: '0 auto' }}></div>
                </div>

                <div className="fade-in-up" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', marginBottom: '5rem', alignItems: 'center' }}>
                    <div>
                        <p style={{ fontWeight: 400, lineHeight: 1.8, marginBottom: '1.5rem', color: colors.text, fontSize: '1.125rem' }}>
                            Je m'appelle <b>Fabien Noël</b>, spécialiste du pilotage de la performance et de la gestion de trésorerie avec <b>15 ans d'expérience en direction financière, audit et contrôle de gestion</b>, en France et à l'international.
                        </p>
                        <p style={{ fontWeight: 400, lineHeight: 1.8, color: colors.text, fontSize: '1.125rem' }}>
                            <b>Mon constat :</b> les dirigeants de PME n'ont pas besoin de méthodes de grands groupes, mais de repères clairs, fiables et actionnables pour mieux décider. Aujourd'hui, j'accompagne des entreprises engagées dans une dynamique de croissance durable, convaincues que leur fonction finance est un levier stratégique et non un centre de coût.
                        </p>
                    </div>
                    <div style={{ backgroundColor: colors.lightBlueBg, padding: '2.5rem', borderRadius: '12px' }}>
                        <h3 style={{ fontWeight: 'bold', marginBottom: '1.5rem', fontSize: '1.25rem', color: colors.primary }}>
                            Pour les dirigeants de PME qui souhaitent :
                        </h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            {[
                                "Décider sur la base d'indicateurs clairs",
                                "Anticiper les tensions de trésorerie",
                                "Sécuriser leurs investissements",
                                "Se concentrer sur leur rôle stratégique"
                            ].map((item, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: colors.secondary, flexShrink: 0 }}></div>
                                    <p style={{ margin: 0, fontSize: '1.05rem', color: colors.text, fontWeight: 500 }}>{item}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="fade-in-up" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
                    {[
                        {
                            title: "Approche pragmatique",
                            text: "Adaptée à votre réalité",
                            icon: (
                                <svg style={{ width: '2rem', height: '2rem', color: colors.secondary }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.384-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                                </svg>
                            )
                        },
                        {
                            title: "Vision stratégique",
                            text: "Au service de votre croissance",
                            icon: (
                                <svg style={{ width: '2rem', height: '2rem', color: colors.secondary }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 002 2h2a2 2 0 002-2z" />
                                </svg>
                            )
                        },
                        {
                            title: "Présence opérationnelle",
                            text: "À vos côtés sur le terrain",
                            icon: (
                                <svg style={{ width: '2rem', height: '2rem', color: colors.secondary }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            )
                        }
                    ].map((item, index) => (
                        <div key={index} style={{ backgroundColor: '#fff', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', padding: '2rem', borderRadius: '8px', textAlign: 'center', borderTop: `4px solid ${colors.secondary}` }}>
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                                {item.icon}
                            </div>
                            <h4 style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: colors.primary, fontSize: '1.1rem' }}>
                                {item.title}
                            </h4>
                            <p style={{ fontSize: '1rem', color: colors.textLight, margin: 0 }}>
                                {item.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
